import { call, put, select } from 'redux-saga/effects';
import { callWithAuth } from '../../sagaApiHelper';
import { sendWhatsappApi } from '../../../api/apiLists/sendWhatsappApi';
import { showAlert } from '../../alertSlice';
import { setLoading, setSuccess, setError, resetWhatsappState } from '../../whatsappSlice';
import { getOrFetchWabaId } from './utils';

export function* handleSendWhatsapp(action) {
  try {
    yield put(setLoading(true));
    const payload = action.payload || {};

    const companyInfo = yield select(state => state.companyInfo?.info || {});
    const wabaIdFromStorage = yield call(getOrFetchWabaId);
    const wabaId = wabaIdFromStorage || companyInfo?.wabaId || companyInfo?.whatsappBusinessAccountId || '';

    if (!wabaId) {
      yield put(showAlert({ message: 'WhatsApp Business Account not found for your company. Please Connect with Meta first.', type: 'error' }));
      yield put(setLoading(false));
      return;
    }

    const companyId = yield select(state => state.auth?.user?.companyId || companyInfo?.companyId || companyInfo?.id || '');

    const companyData = {
      companyId,
      wabaId,
      messageType: 'TEMPLATE'
    };

    const finalPayload = {
      ...payload,
      ...companyData
    };

    const res = yield call(callWithAuth, sendWhatsappApi, finalPayload);

    if (res?.status === true) {
      yield put(setSuccess(true));
      yield put(resetWhatsappState());
    } else {
      yield put(setError(res?.errMsg || 'Failed to send WhatsApp message'));
      yield put(showAlert({ message: res?.errMsg || 'Failed to send WhatsApp message', type: 'error' }));
    }
  } catch (error) {
    console.error('Error sending WhatsApp message:', error);
    yield put(setError('Error occurred while sending WhatsApp message'));
    yield put(showAlert({ message: 'Error occurred while sending WhatsApp message', type: 'error' }));
  } finally {
    yield put(setLoading(false));
  }
}
